import { css } from 'styled-components';

export default css`{
    max-height: 100%;
    overflow: auto;
}`;
